module.exports = __webpack_public_path__ + "static/media/chart.9bb0ae89.svg";